<template>
    <div id="app">
        <!--load banner-->
        <banner v-if="isBanner"></banner>

        <div class="wrapper pull-right">

            <!--load navbar-->
            <navbar container="container">

                <li slot="leftNavItems" v-if="useIDP" class="login-btn">

                    <a href="home/private" v-bind:title='$t("login")'>
                        <div style="display: inline-block; font-size: 16px"><i class="far fa-lg fa-unlock-alt"></i></div>
                        {{$t('login')}}
                    </a>
                </li>

                <li slot="leftNavItems" v-if="ssoType && !useIDP" class="login-btn">

                    <a href="Authentication/LoginByOpenIdSSo?action=showLogin" v-bind:title='$t("login")'>
                        <div style="display: inline-block; font-size: 16px"><i class="far fa-lg fa-unlock-alt"></i></div>
                        {{$t('login')}}
                    </a>
                </li>

                <li class="js_loginPanel login-btn" v-if="!ssoType  && !useIDP" v-on:click.stop.prevent="preventPanel()"
                    slot="leftNavItems">

                    <a href="#" class="dropdown-toggle" v-on:click="togglePanel($event)" v-bind:title='$t("login")'>
                        <div style="display: inline-block; font-size: 14px"><i class="far fa-lg fa-unlock-alt"></i></div>
                        {{$t('login')}}
                        <span class="caret" v-if="!ssoType"></span>
                    </a>

                    <!--load login-->
                    <login v-if="!ssoType"></login>
                </li>
            </navbar>
            <div class="container wrapper-padding">
                <!--load pages here-->
                <router-view></router-view>
            </div>
            <div class="scroll-top" style="display: table;">
                <div style="margin: auto; display: table-cell; vertical-align: middle; text-align: center;"><i class="far fa-2x fa-chevron-up"></i></div>
            </div>
            <footer v-bind:class="{hasHomeData: 'public-footer'}" v-if="showFooter">
                <small class="js_number">
                    &copy;{{$t('footer.rights')}}
                </small>
                <br/>
                <small class="js_number">
                    <a :href="$t('footer.url')" target="_blank">{{$t('footer.powered_by_raybpms')}}</a>
                </small>
            </footer>
        </div>
    </div>
</template>
<script>
    import Modal from './component/widgets/modal/modal.vue';
    import Banner from './component/banner/banner.vue';
    import Navbar from './component/navbar/navbar.vue';
    import Login from './component/login/login.vue';

    import {App} from './assets/ts/global';

    const app = new App();

    export default {
        data() {
            return {
                ssoType: false,
                isBanner: payload.isBanner,
                bodyBackground: payload.bodyBackground,
                hasHomeData: payload.announcementItems.length > 0 && payload.newsItems.length > 0
            }
        },
        computed: {
            showFooter() {
                return !payload.hideFooter
            },
            useIDP() {
                return payload.useIDP;
            }
        },
        mounted() {
            this.ssoType = payload.isOpenId;

            // load ts file
            app.loadMethods();

            $(window).on('click', (e) => {
                if (e.button === 0)
                    this.closePanel();

            });

            $('.navbar-right > li:not(.js_loginPanel)').on('click', (e) => {
                if (e.button === 0)
                    this.closePanel();
            })
        },
        methods: {
            togglePanel() {
                $('.js_loginPanel').toggleClass('open');
            },
            closePanel() {
                $('.js_loginPanel').removeClass('open');
            },
            preventPanel() {
                $('.navbar-right > li:not(.js_loginPanel)').removeClass('open')
            },
        },
        components: {
            Banner,
            Modal,
            Navbar,
            Login
        }
    }

</script>
